/// <reference path="../EventEmitter.ts" />

namespace MACRAIL.UI {

export class Menu extends EventEmitter {

    /**
     * Configuration
     */
    private opts: MenuOptions;

    /**
     * qTip API
     */
    private qTip: QTip2.Api;

    /**
     * The HTML element for the item the current menu was triggered on, e.g. <tr>.
     */
    private selectedItem: JQuery;

    /**
     * Create a new menu
     */
    constructor(opts: MenuOptions) {
        super();

        opts.itemSelector = opts.itemSelector || 'tr';

        this.opts = opts;

        this.qTip = MACRAIL.Helpers.createQtip({
            'target': opts.element,
            'position': 'below',
            'class': 'info',
            'extraClasses': 'qtip-menu',
            'title': '',
            'content': opts.content,
        });

        this.opts.element.on('click', opts.targetClass, (e: JQueryEventObject) => {
            let $button = $(e.currentTarget);

            this.selectedItem = $button.closest(this.opts.itemSelector);

            let selectedId: string = this.selectedItem.data('id');
            let selectedIsEditable: boolean = this.selectedItem.data('editable');

            this.qTip.hide();

            this.qTip.set('position.target', $button);
            this.opts.content.find('a').each(function(i: number, el: Element) {
                let $el = $(el);
                let href: string = $el.data('href');
                if (href) {
                    href = href.replace('{id}', selectedId);
                    $el.attr('href', href);
                }
            });

            this.opts.content.find('li[data-menu-name="edit"]')[!selectedIsEditable ? 'hide' : 'show']();
            this.opts.content.find('li[data-menu-name="audit-history"]')[!selectedIsEditable ? 'hide' : 'show']();
            this.opts.content.find('li.divider')[!selectedIsEditable ? 'hide' : 'show']();

            this.qTip.show();

            let event: MenuOpenedEvent = {
                'selectedItem': this.selectedItem,
                'jQueryEvent': e,
            };
            this.trigger('opened', event);
        });

        this.opts.content.on('click', 'li', (e: JQueryEventObject) => {
            let name = $(e.currentTarget).data('menu-name');

            let event: MenuItemClickedEvent = {
                'name': name,
                'selectedItem': this.selectedItem,
                'jQueryEvent': e,
            };

            this.trigger('itemclick', event);
            this.trigger('itemclick', name, event);

            this.qTip.hide();
        });
    }

    /**
     * Get the qTip for this menu.
     */
    public getQTip() {
        return this.qTip;
    }
}

}

interface MenuOptions {
    element: JQuery;
    content: JQuery;
    itemSelector?: string;
    targetClass: string;
}

interface MenuOpenedEvent {
    selectedItem: JQuery;
    jQueryEvent: JQueryEventObject;
}

interface MenuItemClickedEvent {
    name: string;
    selectedItem: JQuery;
    jQueryEvent: JQueryEventObject;
}
